<template>
    <div class="bg_fff">
        <div class="container">
            <div class="width100 box">
                <div class="bg_fff">
                    <Breadcrumb :pages="pages">
                        <span slot="append" class="fs14 color_main ml20 underline pointer flright append" @click="$router.back()">返回上一页</span>
                    </Breadcrumb>
                </div>
                <!--<div class="bg_fff fs18 wid border_under pt20 pb20 pl20 pr20">首页 > 预约挂号>{{$route.query.title.hosName || ""}}>{{$route.query.title.deptName || ""}}>{{$route.query.title.docName || ""}}<span class="fs14 color_main ml20 underline pointer flright " @click="$router.back()">返回上一页</span></div>-->
                <h3 class="bg_fff pt20 pl20 pr20 pb20"><img src="../../assets/icon/Rectangle2.png" class="mr10 imgb">挂号信息确认</h3>
                <div class="bg_fff flex jcb">
                    <div class="pl20 pr20 width100">
                        <span class="pt10 fs16 fb">{{orderInfo.schdate|schdateFilter}}&nbsp;&nbsp;&nbsp;{{orderInfo.ampm|ampmFilter}}&nbsp;&nbsp;&nbsp;{{orderInfo.numno}}号</span><br>
                        <div class="flleft mr50 pt10 pb10">
                            <span class="diblock pt10 fs12">医院：{{orderInfo.hosName}}</span>
                            <span class="diblock pt10 fs12">科室：{{orderInfo.deptName}}</span>
                        </div>
                        <div class="flleft mr50 pt10 pb10">
                            <span class="diblock pt10 fs12">医生：{{orderInfo.docName}}</span>
                            <span class="diblock pt10 fs12">预估就诊时间：{{orderInfo.numtime}}（以医院实际情况为准）</span>
                        </div>
                        <div class="flleft mr50 pt10 pb10">
                            <span class="diblock pt10 fs12">支付方式：线下支付</span>
                            <span class="diblock pt10 fs12">挂号费：{{orderInfo.regfee}}元</span>
                        </div>
                    </div>
                </div>
                <div class="bg_fff mt20 width100 pt20">
                    <h3 class="bg_fff pl20 pr20 pb20"><img src="../../assets/icon/Rectangle2.png" class="mr10 imgb">患者信息</h3>
                    <el-form ref="form" :model="form" label-width="90px" label-position="left" size="mini" class="mt20 width30 ml20">
                        <el-form-item label="患者姓名:">
                            <el-input v-model="patName"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号:">
                            <el-input v-model="patIdCard"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号:">
                            <el-input v-model="patPhone"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="ml20 pt20 mr20 mt30 bt">
                        <ul class="fs14">
                            <li class="pt20 pb20"><img src="../../assets/icon/xingzhuang.png" class="mr10 imgb">小贴士</li>
                            <li class="pt20 pb20 fs12 fsColor">①  身份证信息必须与就诊者保持一致；</li>
                            <li class="pt20 pb20 fs12 fsColor">②  请输入正确的手机号以接收预约成功的短息信息；</li>
                            <li class="pt20 pb20 fs12 fsColor">③  取消预约截止时间为就诊前一日24：00，逾期将不能取消；</li>
                        </ul>

                    </div>
                    <div class="flex jce mr50 pt10 pb30">
                        <el-button style="margin-right: 37px !important;" @click="$router.back()">取消</el-button>
                        <el-button type="primary" class="mr20" @click="submitForm">确定挂号</el-button>
                    </div>
                </div>

            </div>
        </div>
        <succeed-dialog ref="succeedDialog" :mobile="mobile" @close="closeDialog" @supplement="supplement"></succeed-dialog>
    </div>
</template>

<script>
  import DeptList from "../../components/appointment/dept"
  import OrderRule from "../../components/appointment/order-rule"
  import SucceedDialog from "../../components/appointment/succeed-dialog"
  import {orderTime} from "../../lib/cache/OrderTime";
  import {schdateFilter,ampmFilter} from "../../lib/filters"
  import Breadcrumb from "../../components/common/Breadcrumb"
  import {hosService} from "../../lib/service/hos"

  export default {
    name: "Check",
      props:{
        title: String
      },
    data() {
      return {
        form: {},
        orderInfo: {},
        patName:'',
        patIdCard:'',
        patPhone:'',
        mobile:'',
          pages:[],
          orderId:""//订单id
      }
    },
    computed: {},
    components: {SucceedDialog,Breadcrumb},
    mixins: [],
    filters: {schdateFilter, ampmFilter},
    created() {
      this.orderInfo = orderTime.get()
        this.pages = ["预约挂号",this.orderInfo.hosName,this.orderInfo.deptName,this.orderInfo.docName];
    },
    mounted() {

    },
    methods: {
      async submitForm(){
          if(this.patName==''){
              this.$message.error('患者姓名不能为空！');
              return
          }

         /* if(!/^\d{6}((?:19|20)((?:\d{2}(?:0[13578]|1[02])(?:0[1-9]|[12]\d|3[01]))|(?:\d{2}(?:0[13456789]|1[012])(?:0[1-9]|[12]\d|30))|(?:\d{2}02(?:0[1-9]|1\d|2[0-8]))|(?:(?:0[48]|[2468][048]|[13579][26])0229)))\d{2}(\d)[xX\d]$/.test(this.patIdCard)){
              this.$message.error('身份证格式非法');
              return;
          }*/

          if(!(/^1[3456789]\d{9}$/.test(this.patPhone))){
              this.$message.error('手机号码有误，请重填！');
              return
          }


          const {code,obj}  = await this.$http('smarthos.online.remoteoutpatient.regist',{
                numId:this.orderInfo.numid,//号源id
                bookHosId:this.orderInfo.hosId,//挂号医院id
                bookDeptId:this.orderInfo.deptId+"",//挂号科室id
                bookDocId:this.orderInfo.docid == '*' ? null : this.orderInfo.docid,//挂号医生id 普通门诊可以不填写
                patName:this.patName,//患者姓名
                patIdcard:this.patIdCard,//患者身份证号码
                patMobile:this.patPhone,//患者手机号
            })

        // const options = {
        //   channel: '4',
        //   patnumid: this.orderInfo.numid,
        //   orgid: this.orderInfo.hosId,
        //   patName: this.patName,
        //   patIdcard: this.patIdCard,
        //   patPhone: this.patPhone,
        //     orderType:'1'
        // }
        // const {code,obj} = await this.$http('smarthos.yygh.apiOrderService.teleMedicineRegister',options)

        if(code=='0'){
          this.mobile = obj.patMobile;
          this.orderId = obj.id;//挂号订单id
          this.$refs.succeedDialog.show()
        }
      },
      closeDialog(){
        this.$router.push('/main/registration')
      },
        //补充资料的接口
        async supplement(form){
          const {code,obj} = await hosService.supplement({
              outpatientId:this.orderId,//订单id
              presentingComplaint:form.shjb,//所患疾病
              pastHistory:form.jhs,//既往史
              familyHistory:form.jzs,//家族史
              allergyHistory:form.gms,//过敏史
              illnessCondition:form.bqms,//病情描述
              attaIds:form.attaList//上传图片id数组
          })

            if(code == 0){
                this.$refs.succeedDialog.showSuccsee()
            }
        }
    }
  }
</script>

<style scoped lang="scss">
    .container {
        background-color: #f0f0f0;
        padding: 10px;
        margin: 0 auto;
    }

    .box {
        margin: 0 auto;
    }

    .underline {
        text-decoration: underline;
    }
    .border-l{
        border-left: 1px solid #C9C9C9;
    }
    .border-t{
        border-top: 1px #C9C9C9 dashed;
    }
    .wid{
        border-bottom:1px solid #E8E8E8;
    }
    .flright{
        float: right;
    }
    .imgb{
        vertical-align: bottom;
    }

    .fb{
        font-weight: bold;
    }

    .flleft{
        float: left;
    }
    .diblock{
        display: block;
        color: #666666;;
    }
    .bt{
        border-top: 1px solid #E5E5E5;
    }
    .fsColor{
        color: #999999;
    }
    .imgb{
        vertical-align: bottom;
    }
    .append{
        position: absolute;
        right: 0;
    }
</style>